import React from "react";
import {connect} from "react-redux";
import PropTypes from "prop-types";
import NavigationRequests from "./navigation/navigationRequests";
import {IS_LIXIL_UI} from "../../config";
import MaterialSpinner from "../ui/materialSpinner";
import {COUNTERTOP_GROUP} from "../kvComponent/core/constants";

class AllFeaturesChecker extends NavigationRequests {

  static propTypes = {
    subPart: PropTypes.object.isRequired,
    callBack: PropTypes.func,
    loaderOnly: PropTypes.bool,
    withFiltersRequest: PropTypes.bool,
  };

  constructor(props) {
    super(props);
    this._filtersRequestsMade = [];
  }

  componentDidMount() {
    const {subPart, callBack, withFiltersRequest, filterGroups} = this.props;
    if (withFiltersRequest && !this._filtersRequestsMade.includes(subPart.part.partId) && COUNTERTOP_GROUP.includes(subPart.part.partId)
      && !subPart.part.filtersReceived) {
      this._filtersRequestsMade.push(subPart.part.partId);
      this.checkIfAllFiltersReceived(subPart.part, filterGroups)
        .then(() => {
          if (callBack) {
            callBack()
          }
        });
    }
    this.checkIfAllFeaturesReceived(subPart, "", callBack);
  }

  render() {
    const {loaderOnly} = this.props;
    if (loaderOnly) {
      return IS_LIXIL_UI
        ? <MaterialSpinner/>
        : <div className="message-loading-left-panel-spinner message-loading-left-panel-spinner--small"/>
    }

    return (
      <li className="aq-list__item bold aq-list__item--loading">
        <div className="message-loading-left-panel-spinner message-loading-left-panel-spinner--small"/>
      </li>
    );
  }
}

const mapStateToProps = (store) => {
  return {
    cartItems: store.cartState.cartItems,
    filterGroups: store.filterState.filterGroups,
  };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(AllFeaturesChecker);
